/* NORDE theme scripts — vanilla, no dependencies */
(function(){
  'use strict';

  /* ---------- Mobile drawer ---------- */
  function initDrawer(){
    var burger = document.querySelector('[data-drawer-open]');
    var drawer = document.getElementById('mobile-drawer');
    if(!burger || !drawer) return;
    var closeEls = drawer.querySelectorAll('[data-drawer-close]');
    burger.addEventListener('click', function(){ drawer.classList.add('is-open'); document.body.style.overflow='hidden'; });
    closeEls.forEach(function(el){ el.addEventListener('click', function(){ drawer.classList.remove('is-open'); document.body.style.overflow=''; }); });
  }

  /* ---------- Horizontal carousels (Just arrived) ---------- */
  function initCarousels(){
    document.querySelectorAll('[data-carousel]').forEach(function(root){
      var track = root.querySelector('[data-carousel-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if(!track) return;
      function step(){ var first = track.querySelector('*'); return first ? first.getBoundingClientRect().width + 22 : 320; }
      if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step()*1, behavior:'smooth'}); });
      if(next) next.addEventListener('click', function(){ track.scrollBy({left: step()*1, behavior:'smooth'}); });
    });
  }

  /* ---------- Tabs (What's new) ---------- */
  function initTabs(){
    document.querySelectorAll('[data-tabs]').forEach(function(root){
      var btns = root.querySelectorAll('[data-tab-btn]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      btns.forEach(function(btn){
        btn.addEventListener('click', function(){
          var id = btn.getAttribute('data-tab-btn');
          btns.forEach(function(b){ b.classList.toggle('is-active', b===btn); });
          panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-tab-panel')===id); });
        });
      });
    });
  }

  /* ---------- Product gallery ----------
     The slide change is animated by hand rather than with
     scrollTo({behavior:'smooth'}) or CSS scroll-behavior: both of those get
     cancelled here (the viewport was overflow:hidden originally, and
     scroll-snap aborts scripted scrolling), which left the counter updating
     while the images stayed put. */
  function initGallery(){
    document.querySelectorAll('[data-gallery]').forEach(function(root){
      var viewport = root.querySelector('[data-gallery-viewport]');
      var slides = root.querySelectorAll('.gallery__slide');
      var prev = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      var counter = root.querySelector('[data-gallery-current]');
      var idx = 0, total = slides.length, raf = null;
      if(!viewport || !total) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function go(){
        var slide = slides[idx];
        if(!slide) return;
        if(counter) counter.textContent = (idx+1);
        var target = slide.offsetLeft - slides[0].offsetLeft;
        var start = viewport.scrollLeft;
        var delta = target - start;
        if(raf) cancelAnimationFrame(raf);
        if(reduce || Math.abs(delta) < 2){ viewport.scrollLeft = target; return; }
        var t0 = null, dur = 420;
        function frame(ts){
          if(t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          viewport.scrollLeft = start + delta * (1 - Math.pow(1 - p, 3));
          if(p < 1){ raf = requestAnimationFrame(frame); } else { raf = null; }
        }
        raf = requestAnimationFrame(frame);
      }
      if(prev) prev.addEventListener('click', function(){ idx = Math.max(0, idx-1); go(); });
      if(next) next.addEventListener('click', function(){ idx = Math.min(total-1, idx+1); go(); });
      /* Jump to the slide holding a given media id (used by colour swatches) */
      root.goToMediaId = function(mediaId){
        if(mediaId === null || mediaId === undefined || mediaId === '') return false;
        for(var i=0;i<slides.length;i++){
          if(slides[i].getAttribute('data-media-id') === String(mediaId)){ idx = i; go(); return true; }
        }
        return false;
      };
    });
  }

  /* ---------- Size guide modal ----------
     The chart is authored inside the product description as .norde-sg.
     Lift it out so the description stays short, and show it in a dialog.
     Only move it when there is a button to reopen it with, otherwise the
     chart would vanish into a dialog nothing can open. */
  function initSizeGuide(){
    var modal = document.querySelector('[data-size-guide-modal]');
    var trigger = document.querySelector('[data-size-guide]');
    if(!modal) return;
    var body = modal.querySelector('[data-size-guide-body]');
    var chart = document.querySelector('.pdp__desc .norde-sg');
    if(!chart || !body || !trigger){
      if(trigger) trigger.remove();
      return;
    }
    body.appendChild(chart);
    trigger.hidden = false;
    var supportsDialog = typeof modal.showModal === 'function';
    function open(){
      if(supportsDialog){ modal.showModal(); } else { modal.setAttribute('open',''); }
    }
    function close(){
      if(supportsDialog){ modal.close(); } else { modal.removeAttribute('open'); }
    }
    trigger.addEventListener('click', open);
    modal.querySelectorAll('[data-size-guide-close]').forEach(function(btn){
      btn.addEventListener('click', close);
    });
    // Clicking the backdrop closes: the dialog itself is the click target there.
    modal.addEventListener('click', function(e){ if(e.target === modal) close(); });
  }

  /* ---------- Variant selectors (size / color) ---------- */
  function initVariants(){
    document.querySelectorAll('[data-product-form]').forEach(function(form){
      var data = form.querySelector('[data-variant-json]');
      if(!data) return;
      var variants = JSON.parse(data.textContent || '[]');
      var idField = form.querySelector('[name="id"]');
      var sizeLabel = form.querySelector('[data-size-label]');
      var colorLabel = form.querySelector('[data-color-label]');
      var current = {};
      function showMedia(mediaId){
        if(!mediaId) return;
        document.querySelectorAll('[data-gallery]').forEach(function(g){
          if(typeof g.goToMediaId === 'function') g.goToMediaId(mediaId);
        });
      }
      function match(){
        var v = variants.find(function(vt){
          return Object.keys(current).every(function(k){ return (vt.options||[]).indexOf(current[k])>-1; });
        });
        if(v && idField) idField.value = v.id;
        return v;
      }
      form.querySelectorAll('[data-opt]').forEach(function(input){
        input.addEventListener('change', function(){
          var name = input.getAttribute('data-opt');
          current[name] = input.value;
          var group = form.querySelectorAll('[data-opt="'+name+'"]');
          group.forEach(function(g){ var lbl=g.closest('label'); if(lbl) lbl.classList.toggle('is-active', g.checked); });
          if(name.toLowerCase()==='size' && sizeLabel) sizeLabel.textContent = input.value;
          if((name.toLowerCase()==='color' || name.toLowerCase()==='colour') && colorLabel) colorLabel.textContent = input.value;
          var v = match();
          showMedia(input.getAttribute('data-media-id') || (v && v.media_id));
        });
      });
      // init first checked
      form.querySelectorAll('[data-opt]:checked').forEach(function(i){ current[i.getAttribute('data-opt')]=i.value; });
      match();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty(){
    document.querySelectorAll('[data-qty]').forEach(function(root){
      var input = root.querySelector('input');
      root.querySelector('[data-qty-minus]').addEventListener('click', function(){ input.value = Math.max(1,(parseInt(input.value,10)||1)-1); });
      root.querySelector('[data-qty-plus]').addEventListener('click', function(){ input.value = (parseInt(input.value,10)||1)+1; });
    });
  }

  /* ---------- Quick add to cart ---------- */
  function initQuickAdd(){
    document.querySelectorAll('[data-quick-add]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var id = btn.getAttribute('data-quick-add');
        btn.disabled = true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){return r.json();})
          .then(function(){ updateCartCount(); })
          .catch(function(){})
          .finally(function(){ btn.disabled=false; });
      });
    });
  }
  function updateCartCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; el.style.display = c.item_count>0?'inline-flex':'none'; });
    }).catch(function(){});
  }

  /* ---------- Header: frosted-transparent on scroll ---------- */
  function initHeader(){
    var header = document.querySelector('.header');
    if(!header) return;
    function onScroll(){ header.classList.toggle('header--scrolled', window.scrollY > 40); }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---------- Announcement bar dismiss ---------- */
  function initAnnouncement(){
    document.querySelectorAll('[data-announce-close]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var bar = btn.closest('[data-announce]');
        if(bar) bar.style.display = 'none';
      });
    });
  }

  /* ---------- Before / After comparison slider ---------- */
  function initBeforeAfter(){
    document.querySelectorAll('[data-before-after]').forEach(function(root){
      var before = root.querySelector('[data-ba-before]');
      var handle = root.querySelector('[data-ba-handle]');
      if(!before || !handle) return;
      var dragging = false;
      function setPos(clientX){
        var rect = root.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
      }
      function start(e){ dragging = true; setPos((e.touches?e.touches[0]:e).clientX); e.preventDefault(); }
      function move(e){ if(!dragging) return; setPos((e.touches?e.touches[0]:e).clientX); }
      function end(){ dragging = false; }
      handle.addEventListener('mousedown', start);
      root.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      handle.addEventListener('touchstart', start, {passive:false});
      window.addEventListener('touchmove', move, {passive:false});
      window.addEventListener('touchend', end);
    });
  }

  /* ---------- Back to top ---------- */
  function initToTop(){
    var btn = document.querySelector('[data-to-top]');
    if(!btn) return;
    window.addEventListener('scroll', function(){ btn.classList.toggle('is-visible', window.scrollY>500); }, {passive:true});
    btn.addEventListener('click', function(){ window.scrollTo({top:0,behavior:'smooth'}); });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initDrawer(); initCarousels(); initTabs(); initGallery(); initSizeGuide();
    initHeader(); initAnnouncement(); initVariants(); initQty(); initQuickAdd(); initBeforeAfter(); initToTop(); updateCartCount();
  });
})();
